export default __webpack_public_path__ + "static/media/style.module.30c7415f.less";